import React from 'react';
import {
  ClearableFooter,
  Control,
  DefaultItem,
  RenderMenuItem,
  SingleSelectMenu,
  useDropdown,
  UseDropdownProps,
} from '@adsk/alloy-react-dropdown';

export type DropdownSingleSelectProps<T extends DefaultItem> =
  UseDropdownProps<T> & {
    testId?: string;
    itemRenderer: RenderMenuItem<T>;
    placeholder?: string;
    onClickClearSelectedOption?: () => void;
  };
export const DropdownSingleSelect = ({
  testId,
  items,
  itemRenderer,
  selectedItem,
  onSelectedItemChange,
  placeholder,
  onClickClearSelectedOption,
  ...props
}: DropdownSingleSelectProps<DefaultItem>) => {
  const {
    isOpen,
    menuItems,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    getItemProps,
    selectedItem: selectedItemFromState,
    highlightedIndex,
    targetProps,
  } = useDropdown({
    items,
    selectedItem,
    onSelectedItemChange,
    ...props,
  });
  return (
    <div data-testid={testId}>
      <Control
        isOpen={isOpen}
        selectedItem={selectedItemFromState}
        getToggleButtonProps={getToggleButtonProps}
        getLabelProps={getLabelProps}
        placeholder={placeholder}
        targetProps={targetProps}
      />
      <SingleSelectMenu
        isOpen={isOpen}
        menuItems={menuItems}
        renderMenuItem={itemRenderer}
        targetProps={targetProps}
        highlightedIndex={highlightedIndex}
        selectedItem={selectedItemFromState}
        getMenuProps={getMenuProps}
        getItemProps={getItemProps}
        renderFooter={() =>
          onClickClearSelectedOption ? (
            <ClearableFooter
              setSelectedItems={() => onClickClearSelectedOption()}
            />
          ) : null
        }
      />
    </div>
  );
};
